<template>
    <div class="converter-blurb">
        <slot />
        <div>
            <h3>{{ heading }}</h3>
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Blurb",
    props: {
        heading: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    }
}
</script>

<style>
.converter-blurb {
    display: flex;
    margin-bottom: 25px;
}

.converter-blurb svg {
    width: 29px;
    max-height: 32px;
    margin-right: 10px;
    flex-shrink: 0;
}

.converter-blurb h3 {
    margin: 0;
    font-size: 17px!important;
    line-height: 1.6!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Blurb.vue